var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", [
    _c(
      "a",
      { staticClass: "item_list", attrs: { href: _vm.link, target: "_blank" } },
      [
        _c("div", { staticClass: "thumb_g" }, [
          _c("img", {
            attrs: {
              src: _vm.profileImage,
              width: "54",
              height: "54",
              alt: "",
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "desc_list" }, [
          _c("strong", { staticClass: "tit_list" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "txt_list" }, [
            _vm._v(_vm._s(_vm.description)),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "info_list" }, [
            _vm._v("방문 " + _vm._s(_vm.homeVisitCnt.toLocaleString())),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "info_list" }, [
            _vm._v("회원 " + _vm._s(_vm.memberCount.toLocaleString())),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }